module.exports = __webpack_public_path__ + "static/2019-tattoo-5-755ad125a307a06e14342d0c8cce42b4.jpg";